<template>
    <div class="cashout-sectionTwo-main">
        <div class="cashout-sectionTwo-main__text">
            You are about to initiate a Crators Commission - the number of coyns
            you specify will be exchanged to USD based on the exchange rate
            shown below. This amount will be transferred to the bank account you
            provide. Before you proceed, please note the following:
        </div>
        <div class="cashout-sectionTwo-main__list">
            <ul>
                <li>
                    You can request the Creators Commission for no less than
                    250,000 Coyns.
                </li>
                <li>
                    Once requested, the amount of Coyns to be exchanged will be
                    removed from your account and your request will be reviewed.
                </li>
                <li>
                    The review duration can take up to several workdays during
                    which you may be required to answer some transaction-related
                    questions via the email you provide.
                </li>
                <li>
                    Please understand that it is your responsibility to provide
                    valid information - especially the bank account. Bohemia
                    Interactive A.S. is not liable for any losses due to
                    providing invalid information.
                </li>
                <li>
                    Once the review is finished you will be notified about the
                    result via the e-mail address you provided.
                </li>
                <li>
                    <strong>Before you request</strong>, make sure you have read
                    and understood all the Cash Out terms found
                    <a
                        href="https://data.bistudio.com/ylands/legal/Ylands_Creators_Club_Terms_of_Use.docx"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <strong>here.</strong></a
                    >
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RequestCashbackBodyText',
};
</script>
<style scoped lang="scss">
.cashout-sectionTwo-main {
    height: auto;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;

    @media (max-width: $sm-up) {
        padding: 0 5%;
    }

    &__text {
        @include genericRequestCashbackText();
        grid-row-start: 1;
        grid-column: 1 / 2;
        align-self: center;
        padding-top: 3%;
    }
    &__list {
        @include genericRequestCashbackText();
        grid-row-start: 2;
        grid-column: 1 / 2;

        .here-word {
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
</style>
